"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantsFirestore = void 0;
class ConstantsFirestore {
    constructor(rawFirestore) {
        this.rawFirestore = rawFirestore;
        // construct
    }
    updateWorkConstants(data) {
        return this.rawFirestore.updateWorkConstants(data);
    }
    updateEducationConstants(data) {
        return this.rawFirestore.updateEducationConstants(data);
    }
    updateCreateCharacterConstants(data) {
        return this.rawFirestore.updateCreateCharacterConstants(data);
    }
    updateGameConstants(data) {
        return this.rawFirestore.updateGameConstants(data);
    }
    updateShopConstants(data) {
        return this.rawFirestore.updateShopConstants(data);
    }
    getReflectionQuestions() {
        return this.rawFirestore.getReflectionQuestions();
    }
}
exports.ConstantsFirestore = ConstantsFirestore;
